import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import emailjs from '@emailjs/browser';

@Component({
  selector: 'app-updatevessel-data',
  templateUrl: './updatevessel-data.component.html',
  styleUrls: ['./updatevessel-data.component.scss']
})
export class UpdatevesselDataComponent implements OnInit {
  updateForm: FormGroup;
  ticketForm: FormGroup;

  uploadedFileName = '';
  ticketFileName = '';
  ticketImageUrl = '';

  /* TOAST */
  showToast = false;
  toastMessage = '';
  toastType = 'success';

  projectOptions = ['Port Performance', 'Sailing Performance'];
  savingTypes = ['Time Save', 'Bunker Save'];
  submittedData: any[] = [];

  /* NEW: Module Selection & Dynamic State */
  selectedModule: string = 'SC';
  moduleOptions = ['PC', 'SC', 'CH'];
  
  isScreenshotAdded = false;
  isTicketRaised = false;

  dynamicTicketId = 'SC-2087';

  get isDetailsFilled() {
    const vName = this.ticketForm.get('vesselName')?.value;
    const issueDesc = this.ticketForm.get('issue')?.value;
    return !!(vName && vName.trim() && issueDesc && issueDesc.trim());
  }

  get moduleColorClass() {
    return `module-${this.selectedModule.toLowerCase()}`;
  }

  constructor(private fb: FormBuilder) {
    this.updateForm = this.fb.group({
      vesselName: [''],
      client: [''],
      imo: [''],
      projectSelection: [''],
      port: [''],
      fromPort: [''],
      toPort: [''],
      reportDate: [''],
      savingType: [''],
      remarks: [''],
      documents: [null]
    });

    this.ticketForm = this.fb.group({
      vesselName: ['', Validators.required],
      issue: ['', Validators.required],
      screenshot: [null]
    });
  }

  ngOnInit() {
    this.generateTicketId();
  }

  onModuleChange(module: string) {
    this.selectedModule = module;
    this.generateTicketId();
    // Reset states
    this.ticketForm.reset();
    this.ticketFileName = '';
    this.ticketImageUrl = '';
    this.isScreenshotAdded = false;
    this.isTicketRaised = false;
  }

  generateTicketId() {
    let num = 0;
    if (this.selectedModule === 'PC') num = Math.floor(1000 + Math.random() * 900);
    else if (this.selectedModule === 'SC') num = Math.floor(2000 + Math.random() * 900);
    else if (this.selectedModule === 'CH') num = Math.floor(3000 + Math.random() * 900);
    this.dynamicTicketId = `${this.selectedModule}-${num}`;
  }

  triggerToast(message: string, type = 'success') {
    this.toastMessage = message;
    this.toastType = type;
    this.showToast = true;

    setTimeout(() => {
      this.showToast = false;
    }, 3000);
  }

  async onTicketFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.ticketFileName = file.name;
    this.ticketImageUrl = '';

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'meraki_helpdesk');

    try {
      const response = await fetch(
        'https://api.cloudinary.com/v1_1/drwwvajwk/image/upload',
        {
          method: 'POST',
          body: formData
        }
      );

      const data = await response.json();

      if (data.secure_url) {
        this.ticketImageUrl = data.secure_url;
        this.isScreenshotAdded = true;
        this.triggerToast('Screenshot uploaded successfully ✅');
      } else {
        this.triggerToast('Upload failed ❌', 'error');
      }
    } catch {
      this.triggerToast('Upload error ❌', 'error');
    }
  }

  raiseTicket() {
    if (!this.isDetailsFilled) {
      this.triggerToast('Fill Vessel Name & Issue', 'error');
      return;
    }

    if (!this.ticketImageUrl) {
      this.triggerToast('Upload screenshot first', 'error');
      return;
    }

    const templateParams = {
      ticket_id: this.dynamicTicketId,
      vessel_name: this.ticketForm.value.vesselName,
      issue: this.ticketForm.value.issue,
      attachment: this.ticketFileName,
      screenshot: this.ticketImageUrl,
      to_email: 'ansh243502@gmail.com'
    };

    emailjs.send(
      'service_zrfx2zl',
      'template_8fq8mrc',
      templateParams,
      'nrA2-lkSeYBoZrVjv'
    ).then(() => {
      this.isTicketRaised = true;
      this.triggerToast(`Mail sent successfully | Ticket ${this.dynamicTicketId} ✅`);

      // Reset form after a small delay to show full success state
      setTimeout(() => {
        this.ticketForm.reset();
        this.ticketFileName = '';
        this.ticketImageUrl = '';
        this.isScreenshotAdded = false;
        this.isTicketRaised = false;
        this.generateTicketId();
      }, 4000);
    }).catch(() => {
      this.triggerToast('Mail sending failed ❌', 'error');
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];

    if (file) {
      this.uploadedFileName = file.name;
      this.updateForm.patchValue({ documents: file });

      this.triggerToast('Document uploaded successfully ✅');
    }
  }

  submitForm() {
    const payload = {
      vesselName: this.updateForm.value.vesselName,
      client: this.updateForm.value.client,
      imo: this.updateForm.value.imo,
      projectSelection: this.updateForm.value.projectSelection,
      documentName: this.uploadedFileName
    };

    this.submittedData.unshift(payload);

    this.updateForm.reset();
    this.uploadedFileName = '';

    this.triggerToast('Vessel data submitted successfully ✅');
  }
}